import { z } from "zod";

export const ZVersion = z.object({
  type: z.literal("version"),
  version: z.string().optional(),
});
export type Version = z.infer<typeof ZVersion>;
